import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Colors, Animation } from "../../styles";

const JobCard = ({ jobItem }) => {
	return (
		<Card
			initial={"initial"}
			animate={"animate"}
			exit={"initial"}
			variants={Animation.cards.opacityVariants}
		>
			<div>
				<CardTitle>
					<CardLink
						target="_blank"
						aria-label={`${jobItem.title}. (Opens in a new tab)`}
						href={jobItem.hosted_url}
						dangerouslySetInnerHTML={{ __html: jobItem.title }}
					></CardLink>
				</CardTitle>

				{jobItem.description && (
					<CardDescription
						dangerouslySetInnerHTML={{ __html: jobItem.description }}
					></CardDescription>
				)}
			</div>
			<Tags>
				{jobItem.commitment && <Tag dangerouslySetInnerHTML={{ __html: jobItem.commitment }}/>}
				{jobItem.department && <Tag dangerouslySetInnerHTML={{ __html: jobItem.department }}/>}
				{jobItem.location && <Tag dangerouslySetInnerHTML={{ __html: jobItem.location }}/>}
			</Tags>
		</Card>
	);
};

export default JobCard;

JobCard.propTypes = {
	jobItem: PropTypes.object,
};

const Card = styled(motion.li)`
	list-style: none;
	margin: 0;
	padding: 2.5rem;
	border-radius: 10px;
	border: 1px solid #000;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 5rem;
	position: relative;
`;

const CardDescription = styled.p`
	font-size: 1.4rem;
	line-height: 2rem;
`;

const CardTitle = styled.h3`
	font-size: 1.8rem;
	line-height: 2.1rem;
	font-weight: 900;
	margin-bottom: 1rem;
`;

const CardLink = styled.a`
	display: block;
	color: ${Colors.base.black};

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;

const Tag = styled.span`
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.3rem;
	text-transform: uppercase;
	display: flex;
	gap: 0.47rem;
	align-items: center;
	border-radius: 2px;
	background-color: ${Colors.cneAreas.yellow};
	padding: 0.5rem 0.7rem;
	width: fit-content;
`;

const Tags = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;
